import React from "react";
import ErrorPage from "../ErrorPage";
import config from "../../../config";
import {Header, Footer, Notifications} from "@armus/armus-dashboard";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        console.error(error);
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return (
                <React.Fragment>
                    <Header
                        isLoading={false}
                        leftNav={[]}
                        rightNav={[]}
                        profileNav={[]}
                        userName={undefined}
                        loginUrl={config.endpoints.login}
                    />

                    <ErrorPage statusCode={999} />

                    <Footer navLinks={[]} />
                    <Notifications />
                </React.Fragment>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;